import classNames from "classnames";
import React from "react";
import classes from "./styles.module.scss";

interface BoxProps {
  vertical?: boolean;
}
/**
 * The box is a bordered container
 * @param props
 */
function Box(props: BoxProps & React.HTMLAttributes<HTMLDivElement>) {
  const boxClasses = classNames(
    classes.Box,
    props.className,
    props.vertical ? classes.Vertical : ""
  );
  return <div className={boxClasses}>{props.children}</div>;
}

export default Box;
